import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Ticket from './ticket';

const trMan = require('ts-translate-js').default;
const tr = trMan.boundTR;

class CartSubItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailsShown: true
        };
    }

    componentDidUpdate() {
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    }
    
    handleShowDetails() {
        this.setState({detailsShown: !this.state.detailsShown});
    }

    render() {
        return <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12 text-bold">
                        {this.props.cartItem.Name}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {tr("cartcontent.venue")} {this.props.cartItem.VenueName}
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 btn-toolbar">
                        <div className="btn-group">
                            {/* <button type="button" className={cIf({ btn: true, "btn-default":true, "btn-xs": true, active: this.state.detailsShown } )} onClick={() => this.handleShowDetails()}>
                                <span className="glyphicon glyphicon-list"></span>
                                &nbsp;{ this.state.detailsShown
                                        ? tr('cartcontent.hidedetails')
                                        : tr('cartcontent.showdetails')}
                            </button> */}
                        </div>
                    </div>
                </div>

                {this.state.detailsShown && this.props.cartItem.Tickets.map(ticket =>
                    <Ticket ticket={ticket} key={ticket.ProductID} showOnlyWholePricesOnInternet={this.props.showOnlyWholePricesOnInternet} />
                )}
            </div>
        </div>;
    }
}

CartSubItem.propTypes = {
    cartItem: PropTypes.object,
    onContentChange: PropTypes.func,
    showOnlyWholePricesOnInternet: PropTypes.bool
};

export default CartSubItem;
